import { speechRecognition } from "@/api/tim";

const state = () => {
  return {};
};

const mutations = {};

const actions = {
  speechRecognition({ commit }, data) {
    return new Promise((resolve, reject) => {
      speechRecognition(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
